@if (!chatNandaService.isOpen) {
    <div
        mat-raised-button
        #tooltipBtn
        class="nanda-chat-component-minimized"
        fxLayout="column"
        fxLayoutAlign="center center"
        (click)="chatNandaService.open(); handleOpenChat.emit()"
    >
        <div class="nanda-chat-component-minimized__tooltip">
            <div class="nanda-chat-component-minimized__tooltip-area">
                <span> Como posso te ajudar na análise? </span>
            </div>
        </div>
        <img
            src="/images/logos/nanda-icon-logo.svg"
            width="31.2px"
            height="15.6px"
        />
    </div>
}
